import axios from "axios";
import { request } from "http";

export const API_DOMAIN = `${process.env.REACT_APP_BACKEND_URL}`;
export const HEADERS = {
  headers: { "Access-Control-Allow-Origin": API_DOMAIN },
};
// Should replace base url with env variable
const superAgent = axios.create({
  withCredentials: true,
  baseURL: API_DOMAIN,
  timeout: 10000,
});

const dataAgent = axios.create({
  withCredentials: true,
  baseURL: API_DOMAIN,
  timeout: 10000,
});

dataAgent.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      window.location.replace("/logout");
      return Promise.reject(error);
    }
  }
);

const Users = {
  getAll: (typeName: string = "") => superAgent.get(`data/${typeName}`),
  create: (typeName: string = "", params: Object) =>
    superAgent.post(`${typeName}/h/create/`, { ...params }),
  update: (typeName: string = "", params: Object) =>
    superAgent.post(`${typeName}/h/update/`, { ...params }),
  delete: (typeName: string = "", params: Object) =>
    superAgent.post(`${typeName}/h/delete/`, { ...params }),
  getUsername: (id: number) => superAgent.get(`/data/username?id=${id}`),
};

const DataType = {
  getAll: (typeName: string = "") => dataAgent.get(`data/${typeName}`),
  create: (typeName: string = "", params: Object) =>
    dataAgent.post(`${typeName}/h/create/`, { ...params }),
  update: (typeName: string = "", params: Object) =>
    dataAgent.put(`${typeName}/h/update/`, { ...params }),
  delete: (typeName: string = "", params: Object) =>
    dataAgent.delete(`${typeName}/h/delete/`, { data: { ...params } }),
  updateSortId: (params: Object) =>
    dataAgent.put(`sort/update/`, { ...params }),
};

const SingleItem = {
  get: (typeName: string) => dataAgent.get(`singleItems/get?name=${typeName}`),
  update: (typeName: string = "", data: Object, rawSchema: string) =>
    dataAgent.put(`singleItems/update/`, {
      name: typeName,
      schema: rawSchema,
      data: JSON.stringify(data),
    }),
  create: (typeName: string = "", data: Object, rawSchema: string) =>
    dataAgent.post(`singleItems/create/`, {
      name: typeName,
      schema: rawSchema,
      data: JSON.stringify(data),
    }),
};

const Models = {
  getAll: () => superAgent.get(`data/models/`),
  publish: (params: Object) => superAgent.put(`/publish/`, params),
};

const Hosting = {
  get: () => superAgent.get(`data/hosting/`),
};

const Auth = {
  login: (params: { name: string; password: string }) =>
    superAgent.post("h/login/", { ...params }, { withCredentials: true }),
  logout: () => superAgent.put("h/logout/", {}, { withCredentials: true }),
  validate: () => superAgent.put("h/validate/", {}, { withCredentials: true }),
  register: (params: {
    name: string;
    password: string;
    email: string;
    user_role: string;
  }) => superAgent.post("h/register/", params, { withCredentials: true }),
  requestResetPassword: (params: { email: string }) =>
    superAgent.put("email_reset_password/", params, {
      withCredentials: true,
    }),
  resetPassword: (params: { new_pw: string; reset_id: string }) =>
    superAgent.post("reset_password/", params, { withCredentials: true }),
};

const apiAgent = {
  DataType,
  SingleItem,
  Auth,
  Models,
  Hosting,
  Users,
};

export default apiAgent;
